export function checkIsFlaggingEffectSetIfNeeded(
  isCycleEffect: boolean,
  flaggingEffect: string | null | undefined
): boolean {
  return !isCycleEffect || Boolean(flaggingEffect)
}
